<template>
    <div class="row" id="ErrorTargetProgressList">
        <div class="col-xl-12">
            <div class="panel">
              <div class="d-flex justify-content-end m-3">
                  <el-button @click="exportListCustomer()" size="medium" click="" type="primary"><i class="el-icon-download mr-1"></i> Export</el-button>
              </div>

                <div class="customer-page p-3">
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="12" :md="6">
                            <el-select @change="filter(); getBranch();" v-if="[7,6].includes(keyAccount)|| [295391, 266029].includes(currentUser.id)" v-model="form.area_id" placeholder="Chọn Khu vực" filterable collapse-tags clearable class="w-100 mt-2">
                                <el-option v-for="item in areas" :key="item.id" :label="item.name" :value="item.id" />
                            </el-select>
                        </el-col>

                        <el-col :xs="24" :sm="12" :md="6" v-if="[5,6,7].includes(keyAccount) || this.currentUser.profile.account_type_id === 18 || [295391, 266029].includes(currentUser.id)">
                            <el-select v-model="form.branch_id" @change="filter(); getChildUser(form.branch_id)" placeholder="Chọn văn phòng" filterable clearable class="w-100 mt-2">
                                <el-option v-for="item in branches" :key="item.id" :label="item.name_alias || item.name" :value="item.id" />
                            </el-select>
                        </el-col>

                        <el-col :xs="24" :sm="12" :md="6">
                            <tree-select v-model="form.sale" :normalizer=normalizer
                                         :options="options"
                                         :show-count="true" class="w-100 mt-2"
                                         placeholder="Chọn nhân sự muốn xem..."
                                         search-nested
                                         @input="handleChangeSale" >
                                <!--eslint-disable-->
                                <label slot="option-label"
                                       slot-scope="{ node, shouldShowCount, count, labelClassName, countClassName }"
                                       :class="labelClassName">
                                    <img :src="publicPath + getImageHierarchy(node.raw.profile.account_type.id)" alt="">
                                    <span> {{ node.label }} </span>
                                    <span v-if="shouldShowCount" :class="countClassName">({{ count }})</span>
                                </label>
                            </tree-select>
                        </el-col>

                        <el-col :xs="24" :sm="12" :md="8" :lg="4" :xl="5" v-if="form.sale">
                            <el-select v-model="form.view_as" @change="filter();" clearable class="w-100 mt-2"
                                       placeholder="Chọn tư cách để xem">
                                <el-option v-for="item in watchAs" :key="item.id" :label="item.value"
                                           :value="item.id"/>
                            </el-select>
                        </el-col>

                        <el-col :xs="24" :sm="12" :md="8" :lg="4" :xl="5">
                            <el-select @change="filter" v-model="form.account_type_id" placeholder="Chọn chức vụ" clearable class="w-100 mt-2">
                                <el-option v-for="item in filteredPositions" :key="item.id" :label="item.name" :value="item.id" />
                            </el-select>
                        </el-col>

                        <el-col :xs="24" :sm="12" :md="6">
                            <el-select  @change="filter" v-model="form.type_error" placeholder="Chọn loại lỗi" clearable class="w-100 mt-2">
                                <el-option v-for="item in typeError" :key="item.id" :label="item.name" :value="item.id" />
                            </el-select>
                        </el-col>

                        <el-col :xs="24" :sm="12" :md="6" v-if="form.type_error">
                            <el-select  @change="filter" v-model="form.goal_type" placeholder="Chọn loại mục tiêu" clearable class="w-100 mt-2">
                                <el-option v-for="item in typeGoal" :key="item.id" :label="item.name" :value="item.id" />
                            </el-select>
                        </el-col>

                        <el-col :xs="24" :sm="12" :md="6">
                            <el-date-picker
                                v-model="form.dateRange" class="w-100 mt-2"
                                type="daterange" value-format="yyyy-MM-dd"
                                start-placeholder="Từ ngày "
                                end-placeholder="Đến ngày"
                                @change="filter"/>
                        </el-col>
                    </el-row>

                    <div class="errors-container">
                        <div class="error-card" v-for="(item, index) in errors" :key="index">
                            <CardError :response-error="item" />
                        </div>
                    </div>

                    <div class="table-responsive-lg b-table-sticky-column table-responsive mt-6">
                        <table class="table table-hover table-striped table-bordered table-customer">
                            <thead>
                            <tr>
                                <th>#</th>
                                <th v-for="col in visibleColumns" :key="col.key" :style="col.style">{{
                                        col.label
                                    }}
                                </th>
                            </tr>
                            </thead>
                            <tbody>

                            <tr v-for="(error, key) in tableData" :key="error.id">
                                <td>{{ 25 * (paging.current_page - 1) + key + 1 }}</td>
                                <td v-for="col in visibleColumns" :key="col.key">
                                  <template v-if="col.key === 'process'">
                                        <span>
                                            {{ typeGoalDefine[error.process] + ' ' +  processTypeDefine[error.process_type] }}
                                        </span>
                                  </template>
<!--                                    <template v-else-if="col.key === 'hanh_dong'">-->
<!--                                        <el-row class="action-table" style="text-align: center">-->
<!--                                            <el-tooltip content="Nhập mục tiêu" placement="top">-->
<!--                                                <button-->
<!--                                                    style="background-color: #472F92"-->
<!--                                                    class="btn btn-sm rounded-circle btn-icon waves-effect waves-themed mr-2">-->
<!--                                                    <i class="el-icon-plus text-white"></i>-->
<!--                                                </button>-->
<!--                                            </el-tooltip>-->

<!--                                        </el-row>-->
<!--                                    </template>-->
                                    <template v-else>
                                        {{ error[col.key] }}
                                    </template>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                      <span class="float-right">Tổng bản ghi: <b style="color: #1da7ee">{{paging.total}}</b></span>
                    </div>
                    <div class="edutalk-paging">
                        <div class="block">
                            <!--eslint-disable-->
                            <el-pagination
                                background
                                @current-change="handleCurrentChange"
                                :current-page.sync="paging.current_page"
                                :page-size="15"
                                layout="prev, pager, next"
                                :total="paging.total">
                            </el-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";

import {mapGetters} from "vuex";
import { GET_REGIONS_BY_USER} from "@/core/services/store/customer/customer.module";
import {BRANCH_LIST, GET_CHILD_USER} from "@/core/services/store/service.module";
import {GET_ERROR_TARGET_PROGRESS_LIST, GET_ERROR_TARGET_PROGRESS_TOTAL} from "@/core/services/store/report.module";
import CardError from "@/views/pages/report-error/compoment/CardErrorTargetProgress.vue";
import { debounce } from 'lodash';

export default {
    components: {
        CardError
    },
    data() {
        return {
            page: 1,
            last_page: 1,
            areas: [],
            branches: [],
            tableData: [],
            errors: [],
            options: [],
            debounceQuerySever: null,
            form: {
                area_id: '',
                goal_type: '',
                type_error: '',
                dateRange: '',
                view_as: '',
                account_type_id: '',
                branch_id: '',
                sale: null,
            },
            paging: {
                current_page: 1,
                per_page: 50,
                total: 50,
                count: 15
            },
            typeGoal: [
                {id: 0, name:'Mục tiêu ngày'},
                {id: 1, name:'Mục tiêu tuần'},
                {id: 2, name:'Mục tiêu tháng'}
            ],

          typeError: [
                {id: 5, name:'Quên điền mục tiêu'},
                {id: 6, name:'Không điền mục tiêu'},
                {id: 7, name:'Không đạt mục tiêu'}
           ],
            view_as: [
                {id: 1, name:'Cộng tác viên'},
            ],

            typeGoalDefine: {
                5: 'Quên điền mục tiêu',
                6: 'Không điền mục tiêu',
                7: 'Điền sai mục tiêu',
                8: 'Không đạt mục tiêu'
            },
            processTypeDefine: {
                0: 'ngày',
                1: 'tuần',
                2: 'tháng'
            },
            imageHierarchy: {
              '5': 'media/hierarchy/gdvp.png',
              '1': 'media/hierarchy/sl.png',
              '2': 'media/hierarchy/se.png',
              '3': 'media/hierarchy/s.png',
              '4': 'media/hierarchy/si.png'
            },

            watchAs: [
                {
                    id: 1,
                    value: 'Đội kinh doanh',
                    label: 'Đội'
                },
                {
                    id: 2,
                    value: 'Cá nhân',
                    label: 'Cá nhân'
                }
            ],

            positions: [
                {id: 1, name: 'Sales Leader'},
                {id: 2, name: 'Sales Expert'},
                {id: 3, name: 'Sales'},
                {id: 4, name: 'Sales Intern'},
                {id: 5, name: 'Giám đốc văn phòng'},
                {id: 6, name: 'Giám đốc khu vực'},
                {id: 26, name: 'Giám đốc vùng'},
                {id: 'ctv', name: 'Công tác viên'},
            ],

            keyAccountMap: {
                7: [26, 6, 5, 1, 2, 3, 4, 'ctv'], // BOD
                6: [6, 5, 1, 2, 3, 4, 26, 'ctv'], // Giám đốc vùng
                5: [5, 1, 2, 3, 4, 6, 'ctv'], // Giám đốc khu vực
                4: [1, 2, 3, 4, 5, 'ctv'], // Giám đốc văn phòng
                3: [1,2, 3, 4, 'ctv'], //Sales Leader
            },
          publicPath: process.env.VUE_APP_BASE_URL,

            cache_sale: null
        };
    },

    created() {
        this.debounceQuerySever = debounce(this.querySever, 500);
    },

    computed: {
        ...mapGetters(['currentUser', 'keyAccount']),
        visibleColumns() {
            return  [
                {key: 'user_id', label: 'Mã nhân sự'},
                {key: 'name', label: 'Họ và tên'},
                {key: 'accountType', label: 'Vị trí'},
                {key: 'process', label: 'Loại lỗi'},
                {key: 'branch_name', label: 'Văn phòng'},
                {key: 'area_name', label: 'Khu vực'},
                {key: 'message', label: 'Nội dung'},
                {key: 'boss', label: 'Cấp trên'},
                {key: 'is_ctv', label: 'Cộng tác viên'},
                {key: 'date_appear', label: 'Thời gian lỗi'},
                // {key: 'hanh_dong', label: 'Hành động', style: 'width: 180px'},
            ];
        },
        filteredPositions() {
            if (!this.keyAccount) return this.positions;
            const ids = this.keyAccountMap[this.keyAccount] || [];
            return this.positions.filter(p => ids.includes(p.id));
        }
    },

    mounted() {
        this.$store.dispatch(SET_BREADCRUMB, [
            {title: "Bảng báo lỗi tiến độ mục tiêu", icon: "fas fa-list"},
        ]);
        this.setDefaultDateRange();
        this.querySever();
        this.getRegions();
        this.getBranch();
        this.totalError();
        this.getChildUser();
    },

    watch: {},

    methods: {
        getChildUser() {
            var branchId = '';
            if([1,5].includes(this.currentUser.account_type.id)){
                branchId = this.currentUser.profile.chi_nhanh_id;
            }

            const payload = {
                branch_id: this.form.branch_id || branchId,
            }

            this.$store.dispatch(GET_CHILD_USER, payload)
                .then((response) => {
                    if (response.status === 422) {
                        this.$message({type: 'warning', message: `${response.message}`, showClose: true});
                    } else {
                        this.childUsers = response.data;
                        this.options = response.data;
                    }
                });
        },

        querySever() {
            const params = this.form;
            this.totalError(params);
            params.page = this.paging.current_page;
            this.$store.dispatch(GET_ERROR_TARGET_PROGRESS_LIST, params)
                .then((response) => {
                    if (response.status === 422) {
                        this.$message({type: 'warning', message: `${response.message}`, showClose: true});
                    } else {
                        this.tableData = response.data;
                        this.total = response.data.total;
                        this.paging = response.pagination
                    }
                    this.loading = false;
                }).finally(() => {
            })
        },

           // Khởi tạo dateRange mặc định là tháng hiện tại
        setDefaultDateRange() {
           const today = new Date();
           const year = today.getFullYear();
           const monthIndex = today.getMonth();
           const mm = String(monthIndex + 1).padStart(2, '0');
           const startOfMonth = `${year}-${mm}-01`;
           const lastDay = new Date(year, monthIndex + 1, 0).getDate();
           const endOfMonth = `${year}-${mm}-${String(lastDay).padStart(2, '0')}`;
           this.form.dateRange = [startOfMonth, endOfMonth];
        },

        totalError(params) {
          this.$store.dispatch(GET_ERROR_TARGET_PROGRESS_TOTAL, this.form)
              .then((res) => {
                if(res.status === 200) {
                    this.errors = res.data;
                } else {
                    this.$message({type: 'warning', message: `${res.message}`, showClose: true});
                }

              }).finally(() => {
          })
        },

        getRegions() {
            const payload = {
                all: this.keyAccount === 7 ? 1 : 0
            };
            this.$store.dispatch(GET_REGIONS_BY_USER, payload)
                .then((response) => {
                    if (response.status === 422) {
                        this.$message({type: 'warning', message: `${response.message}`, showClose: true});
                    } else {
                        this.areas = response.data;
                    }
                })
        },

        getBranch() {
            const payload = {
               area_id: this.form.area_id
            };

            this.$store.dispatch(BRANCH_LIST,payload)
                .then((response) => {
                    if (response.status === 422) {
                        this.$message({type: 'warning', message: `${response.message}`, showClose: true});
                    } else {
                        this.branches = response.data;
                    }
                })
        },

        handleCurrentChange(val) {
            this.currentPage = val;
            this.querySever({page: val});
        },


        handleChangeSale() {
          this.querySever();
        },

      normalizer: function (node) {
        return {
          id: node.id,
          label: node.name,
        }
      },

      getImageHierarchy(account_type) {
        return this.imageHierarchy[account_type];
      },

      exportListCustomer() {
        const url = this.getExportUrl();
        window.open(url, '_blank');
      },

      getExportUrl() {
        const params = { ...this.form, is_export: 1 };
        const parts = [];

        Object.entries(params).forEach(([key, value]) => {
          if (Array.isArray(value)) {
            // với mảng thì tạo key[]=val cho mỗi phần tử
            value.forEach(val => {
              parts.push(`${encodeURIComponent(key)}[]=${encodeURIComponent(val)}`);
            });
          } else {
            parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(value ?? '')}`);
          }
        });

        const queryString = parts.join('&');
        return `${process.env.VUE_APP_API_URL}/export-error-target-progress?${queryString}`;
      },
      filter(){
        this.paging.current_page = 1;
        this.querySever();
      }
    },
};
</script>

<style scoped>
.errors-container {
    background-color: #F9F7FA;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    margin-top: 20px;
    padding: 20px;
    border-radius: 10px;
}
.error-card {
    padding: 20px;
    border-radius: 10px;
    background: white;
}

/* Khi viewport ≤600px, bỏ grid, xếp dọc */
@media (max-width: 600px) {
    .errors-container {
        display: block;    /* hoặc display:flex; flex-direction:column; */
        padding: 10px;     /* tuỳ chỉnh */
    }
    .error-card {
        margin-bottom: 20px;
    }
}
</style>
